globalThis.CalendlyModule = (function() {
    function CalendlyModule($html) {
        this.$html = $html;
    }

    CalendlyModule.initWidgets = function($html) {
        var $html = $html || $('body');

        $html.find('.calendly-widget').each(function() {
            new CalendlyModule($(this)).init();
        });
    }

    CalendlyModule.getEvent = function(event, callback) {
        $.ajax({
            method: "GET",
            url: assets.calendly_get_event,
            data: { event: event },
            success: function (data) {
                if(typeof(callback) == 'function') callback(data);
            }
        })
    }

    CalendlyModule.prototype = {
        init: function() {
            var _this = this;
            utils.require([assets.calendly], function() {
                _this._initWidget();
                _this._initEvents();
            });
        },
        _initWidget: function(){
            var _this = this;

            this.dataContactSettings = _this.$html.data("contact-settings");
            this.dataUrlSettings = _this.$html.data("url-settings");
            this.dataEmbedSettings = _this.$html.data("embed-settings") || {};
            this.inputRef = _this.$html.data("input-ref");

            this.options = {
                prefill: {
                    name: _this.dataContactSettings.name,
                    firstName: _this.dataContactSettings.firstName,
                    lastName: _this.dataContactSettings.lastName,
                    email: _this.dataContactSettings.email,
                    customAnswers: {
                        a1: _this.dataContactSettings.customAnswers.a1,
                        a3: _this.dataContactSettings.customAnswers.a3,
                    }
                }
            }

            if(this._isInlineWidget()) {
                var urlOptions = $.extend({
                    hide_gdpr_banner: true,
                    hide_landing_page_details: true,
                    hide_event_type_details: true
                }, this.dataEmbedSettings);

                Object.keys(urlOptions).forEach(key => {
                    if (urlOptions[key] === false) {
                        delete urlOptions[key];
                    } else {
                        urlOptions[key] = 1
                    }
                });


                this.options.url = `${this.dataUrlSettings}?${$.param(urlOptions)}`;
                this.options.parentElement = this.$html;

                Calendly.initInlineWidget(this.options);

            } else if(this._isPopupWidget()) {
                var urlOptions = $.extend({
                    hide_gdpr_banner: false,
                    hide_landing_page_details: false,
                    hide_event_type_details: false
                }, this.dataEmbedSettings);

                Object.keys(urlOptions).forEach(key => {
                    if (urlOptions[key] === false) {
                        delete urlOptions[key];
                    } else {
                        urlOptions[key] = 1
                    }
                });

                this.options.url = `${this.dataUrlSettings}?${$.param(urlOptions)}`;

                this.$html.on('click', function(){
                    Calendly.initPopupWidget(_this.options);
                })
            }
        },
        _isInlineWidget: function(){
            return this.$html.data('mode') == undefined || this.$html.data('mode') == 'inline';
        },
        _isPopupWidget: function(){
            return this.$html.data('mode') == 'popup';
        },
        _isCalendlyEvent: function(e) {
            return e.data.event && e.data.event.indexOf('calendly') === 0;
        },
        _initEvents: function() {
            var _this = this;
            window.addEventListener('message', function(e) {
                if (_this._isCalendlyEvent(e)) {
                    switch(e.data.event) {
                        case "calendly.profile_page_viewed":
                            _this.$html.trigger("calendly_profile_page_viewed");
                            break;
                        case "calendly.event_type_viewed":
                            _this.$html.trigger("calendly_event_type_viewed");
                            if(_this._isInlineWidget()) _this.$html.css("height", "700px");
                            break;
                        case "calendly.date_and_time_selected":
                            _this.$html.trigger("calendly_date_and_time_selected");
                            if(_this._isInlineWidget()) _this.$html.css("height", "1300px");
                            break;
                        case "calendly.event_scheduled":
                            if(_this._isInlineWidget()) _this.$html.css("height", "740px");
                            CalendlyModule.getEvent(e.data.payload.event, function(response) {
                                if(_this.inputRef) $(_this.inputRef).val(response.scheduled_at);
                                if(_this._isPopupWidget()) setTimeout(function() {$('.calendly-overlay').fadeOut(500, function(){ _this.$html.remove(); })}, 2000);
                                _this.$html.trigger("calendly_event_scheduled");
                            });
                            break;
                    }
                };
            });
        }
    }

    return CalendlyModule;
})();
